import { useEffect } from 'react'

import { type RealtimePrivacy, subscribe } from './realtime'
import { type Unsubscribe } from './fayeClient'

const useRealtimeSubscription = (
  privacy: RealtimePrivacy,
  channel: `/${string}`,
  onMessage: (message: unknown) => void
) => {
  useEffect(() => {
    let isCancelledWhilePending = false
    let unsubscribe: Unsubscribe | undefined

    void subscribe(privacy, channel, (message) => {
      if (!isCancelledWhilePending) onMessage(message)
    })
      .then((cancel) => {
        if (isCancelledWhilePending) {
          cancel()
        } else {
          unsubscribe = cancel
        }
      })
      .catch((error: unknown) => {
        console.error(
          `Could not subscribe to realtime ${privacy} ${channel}`,
          error
        )
      })

    return () => {
      if (unsubscribe) {
        unsubscribe()
      } else {
        isCancelledWhilePending = true
      }
    }
  }, [privacy, channel, onMessage])
}

export { useRealtimeSubscription }
